import AuthSvcMod from '@Services/Auth.svc.js';
import DOMHelpersSvcMod from '@Services/DOMHelpers.svc.js';
import IntercomSvcMod from '@Services/Intercom.svc.js';
import MetricsSvcMod from '@Services/Metrics.svc.js';
import NavSvcMod from '@Services/Nav.svc.js';
/** @typedef {import('./Scripts.svc')} Types */
//
export class Scripts {
	constructor(
		$rootScope,
		$q,
		$log,
		$window,
		ENV,
		HOST_URL,
		G_TAG_URL,
		G_TAG_ID,
		API,
		$state,
		NavSvc,
		IntercomService,
		MetricsSvc,
		AuthSvc,
		DOMHelpersSvc
	) {
		'ngInject';
		this.$rootScope = $rootScope;
		this.$q = $q;
		this.$log = $log;
		this.$window = $window;
		this.ENV = ENV;
		this.HOST_URL = HOST_URL;
		this.G_TAG_URL = G_TAG_URL;
		this.G_TAG_ID = G_TAG_ID;
		this.API = API;
		this.$state = $state;
		this.NavSvc = NavSvc;
		this.IntercomService = IntercomService;
		this.MetricsSvc = MetricsSvc;
		this.AuthSvc = AuthSvc;
		this.DOMHelpersSvc = DOMHelpersSvc;
		this.GTM_ELM_ID = 'gtmScript';
		this.IC_ELM_ID = 'icScript';
	}

	init() {
		this.$rootScope.$on('$viewContentLoaded', () => {
			this.loadGGLE();
			if (this.ENV !== 'local') this.loadICOM();
		});
	}

	loadGGLE() {
		if (!this.DOMHelpersSvc.getById(this.GTM_ELM_ID)) {
			this.loadGTM(this.GTM_ELM_ID)
				.then(res => {
					window.dataLayer = window.dataLayer || [];
					function gtag() {
						// eslint-disable-next-line no-undef
						dataLayer.push(arguments);
					}
					gtag('js', new Date());
					gtag('config', this.G_TAG_ID);
					this.MetricsSvc.init();
					this.logOnLoadEvent(this.GTM_ELM_ID, res);
				})
				.catch(this.handle_error.bind(this, this.GTM_ELM_ID));
		}
	}

	loadICOM() {
		if (
			this.ENV !== 'development' &&
			this.$state?.current?.name &&
			!this.NavSvc.isStatePublic(this.$state.current.name) &&
			!this.DOMHelpersSvc.getById(this.IC_ELM_ID)
		) {
			this.loadIntercom(this.IC_ELM_ID)
				.then(res => {
					this.logOnLoadEvent(this.IC_ELM_ID, res);
					const _user = this.AuthSvc.currentUser();
					if (_user) this.IntercomService.boot(_user);
				})
				.catch(this.handle_error.bind(this, this.IC_ELM_ID));
		}
	}

	// todo: move function to a n utility service
	/** @param {Event|Object} e */
	stringifyEvent(e) {
		const obj = {};
		Object.keys(e).forEach(k => {
			obj[k] = e[k];
		});

		return JSON.stringify(
			obj,
			(_, v) => {
				if (v instanceof Node) return 'Node';
				// eslint-disable-next-line no-undef
				if (v instanceof Window) return 'Window';
				return v;
			},
			' '
		);
	}

	// intercom
	/** @param {string} elmId */
	loadIntercom(elmId) {
		const _start = Date.now();
		const _def = this.$q.defer();
		const APP_ID = 'wmg4i4pq';
		this.$window.intercomSettings = {app_id: APP_ID};
		const ic = this.$window.Intercom;
		if (typeof ic === 'function') {
			ic('reattach_activator');
			ic('update', this.$window.intercomSettings);
			_def.resolve('icScript: already loaded');
		} else {
			const i = function () {
				i.c(arguments);
			};
			i.q = [];
			i.c = function (args) {
				i.q.push(args);
			};
			this.$window.Intercom = i;
			const src = `https://widget.intercom.io/widget/${APP_ID};`;

			this.DOMHelpersSvc.insertScriptHead(src, elmId)
				.then(() => _def.resolve({_start}))
				.catch(err => _def.reject(err));
		}
		return _def.promise;
	}

	// gtm
	/** @param {string} elmId */
	loadGTM(elmId) {
		const _def = this.$q.defer();
		const _start = Date.now();
		const src = `${this.G_TAG_URL}?id=${this.G_TAG_ID}`;

		this.DOMHelpersSvc.insertScriptHead(src, elmId)
			.then(() => _def.resolve({_start}))
			.catch(err => _def.reject(err));
		return _def.promise;
	}

	/**
	 * @param {string} elementId
	 * @param {Object} res
	 */
	logOnLoadEvent(elementId, res) {
		this.$log.info(`${elementId} loaded in: ${res?._start ? Date.now() - res._start : 0}ms`);
	}

	/**
	 * @param {string} elementId
	 * @param {*} err
	 */
	handle_error(elementId, err) {
		this.$log.error(`fail to load element with ID: ${elementId}, with error: ${this.stringifyEvent(err)}`);
	}
}
//
let svcMod = angular
	.module('mod.svc.ScriptsSvc', [AuthSvcMod, DOMHelpersSvcMod, IntercomSvcMod, MetricsSvcMod, NavSvcMod])
	.service('ScriptsSvc', Scripts);
export default (svcMod = svcMod.name);
